<template>
  <v-card class="mainContainer v-card--flat">
    <v-layout justify-center>
      <v-flex xs11>
        <v-card class="v-card--flat">
          <h2 :style="`color: ${$vuetify.theme.primary}`">
            {{reviewDetails.TotalNrOfReviews}} {{$translate('REVIEWS')}}
          </h2>
         <v-layout row>
           <v-rating readonly
                     half-increments
                     large
                     color="yellow darken-3"
                     background-color="yellow darken-3"
                     v-model="reviewDetails.AverageRating"/>
           <h1 class="mediumOfReviews">{{reviewDetails.AverageRating}}/5</h1>
         </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-timeline dense
                align-top>
      <v-timeline-item
        v-for="(item) in allReviews"
        :key="item"
        :color="getColorForTimeLineBall(item.Rating)"
        large>
        <v-card class="elevation-2">
          <v-layout row>
            <v-flex xs6>
              <v-card-title class="headline">{{item.Name}}</v-card-title>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs3>
              <v-layout justify-end column>
                <v-rating readonly
                          color="yellow darken-3"
                          background-color="yellow darken-3"
                          v-model="item.Rating"/>
                <p>{{item.DateStr}} - {{item.TimeStr}}</p>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-card-text v-html="item.Review"></v-card-text>
          <v-flex xs12>
            <v-layout justify-end>
              <v-btn fab
                     v-if=" item.Response.DateStr === '' &&
                            $store.getters['auth/userLevel'] === 9"
                     small
                     color="primary"
                     @click="addOrRemoveFromList(item.Id)"
                     icon>
                <v-icon medium>reply</v-icon>
              </v-btn>
              <v-btn fab
                     v-if="$store.getters['auth/userLevel'] === 9"
                     small
                     color="primary"
                     @click="deleteReview(item.Id)"
                     icon>
                <v-icon medium>delete</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
          <v-layout v-if="  item.Response.DateStr === '' &&
                            $store.getters['auth/userLevel'] === 9 &&
                            listOfResponses.includes(item.Id)"
                    justify-end
                    row>
            <v-flex xs8>
              <v-textarea
                v-model="item.Response.Response"
                auto-grow
                box
                outline
                solo
                color="primary"
                rows="1"
              />
            </v-flex>
            <v-btn color="primary"
                   @click="addReviewResponse(item)"
                   round>
              {{$translate('INCIDENT_SEND')}}
            </v-btn>
          </v-layout>
          <v-flex class="responseBlock"
                  v-else-if="item.Response.DateStr !== ''"
                  xs12>
            <v-layout row>
              <v-flex xs1>
                <v-layout row justify-center>
                  <v-icon x-large>subdirectory_arrow_right</v-icon>
                </v-layout>
              </v-flex>
              <v-flex xs11 style="padding-right: 7em;">
               <v-layout column
                         justify-center
                         fill-height>
                 <v-layout row justify-space-between>
                   <v-flex xs5>
                     <h2>{{item.Response.Name}}</h2>
                   </v-flex>
                   <v-flex xs5>
                     <p class="pNoMargin"
                        style="text-align: end">
                       {{item.Response.DateStr}} - {{item.Response.TimeStr}}
                     </p>
                   </v-flex>
                 </v-layout>
                 <p class="pNoMargin"
                    v-html="item.Response.Response"/>
               </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card>
      </v-timeline-item>
    </v-timeline>
    <v-flex xs12 style="margin-bottom: 6em;">
      <v-layout justify-center
      align-center
      row>
        <v-btn round
               :disabled="disableLoadMore"
               @click="getReviews()"
               color="primary">
          {{$translate('REVIEWS_LOAD_MORE')}}
        </v-btn>
      </v-layout>
    </v-flex>
  </v-card>
</template>

<script>
import * as dssRequest from '../api/dssRequest';

export default {
  name: 'Reviews',
  components: {
  },
  data() {
    return {
      reviewDetails: {},
      disableLoadMore: false,
      listOfResponses: [],
      allReviews: [],
    };
  },
  props: {
    eventDetails: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    this.getReviews();
  },
  methods: {
    deleteReview(reviewId) {
      const payload = {
        Id: reviewId,
      };
      dssRequest.doRequest(
        (response) => {
          console.log('The generic call deleteReview on '
            + 'Reviews.vue was successful', response);
          this.allReviews = [];
          this.reviewDetails = {};
          this.getReviews();
        },
        (error) => {
          console.log('The generic call deleteReview on '
            + 'Reviews.vue was not successful', error);
        },
        'deleteReview',
        this.eventDetails.EventId,
        payload,
        600000,
        false,
      );
    },
    addReviewResponse(review) {
      const payload = {
        Id: review.Id,
        Review: review.Response.Response,
        Name: this.eventDetails.EventTranslationName,
      };
      dssRequest.doRequest(
        (response) => {
          console.log('The generic call addReviewResponse on '
            + 'Reviews.vue was successful', response);
          this.allReviews = [];
          this.reviewDetails = {};
          this.getReviews();
        },
        (error) => {
          console.log('The generic call addReviewResponse on '
            + 'Reviews.vue was not successful', error);
        },
        'addReviewResponse',
        this.eventDetails.EventId,

        payload,
        600000,
        false,
      );
    },
    getReviews() {
      this.disableLoadMore = true;
      const payload = {
        From: this.allReviews.length,
        Until: this.allReviews.length + 10,
      };
      dssRequest.doRequest(
        (response) => {
          console.log('The generic call getReviews on '
            + 'Reviews.vue was successful', response);
          response.data.Reviews.forEach(review => {
            console.log("Lorenzo review", review);
            review.Review = review.Review.replace(/\n/g, '<br>');
            review.Response.Response = review.Response.Response.replace(/\n/g, '<br>');
            this.allReviews.push(review);
          })
          this.reviewDetails = response.data;
          this.reviewDetails.AverageRating = Number(this.reviewDetails.AverageRating.toFixed(1));
          if(Object.values(response.data.Reviews).length === 10){
            this.disableLoadMore = false;
          }
        },
        (error) => {
          console.log('The generic call getReviews on '
            + 'Reviews.vue was not successful', error);
        },
        'getReviews',
        this.eventDetails.EventId,
        payload,
        600000,
        false,
      );
    },
    addOrRemoveFromList(id) {
      if (this.listOfResponses.includes(id)) {
        this.listOfResponses.splice(this.listOfResponses.indexOf(id), 1);
      } else this.listOfResponses.push(id);
    },
    getColorForTimeLineBall(totalRating) {
      switch (totalRating) {
        case 1:
          return '#FF0000';
        case 2:
          return '#FF7B00';
        case 3:
          return '#FFFF00';
        case 4:
          return '#B0FF00';
        case 5:
          return '#00FF00';
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .mainContainer {
    background: white;
    margin-top: 4em !important;
    margin-bottom: -2em;
    margin-left: -1.7em;
    margin-right: -1.7em;
    padding-bottom: 1em;
    min-height: 500px;
  }
  .mediumOfReviews {
    font-size: 33px;
  }
  .responseBlock {
    background-color: lightgrey;
  }
  .pNoMargin {
    margin-bottom: 0 !important;
  }
</style>
